import { render, staticRenderFns } from "./voucher-add-or-update.vue?vue&type=template&id=9a52597c&scoped=true"
import script from "./voucher-add-or-update.vue?vue&type=script&lang=js"
export * from "./voucher-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./voucher-add-or-update.vue?vue&type=style&index=0&id=9a52597c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a52597c",
  null
  
)

export default component.exports